import type { Stroke } from '@/lib/grader/types'

/**
 * Sample each KanjiVG stroke path into an evenly-spaced point array for
 * curve-matcher. Browser-only (uses SVGPathElement.getPointAtLength). The
 * caller already has `data.strokePaths` from the `useKanji` hook + the
 * `data.viewBox` for normalisation.
 */
export function sampleKanjiVgStrokes(
    strokePaths: string[],
    samplesPerStroke = 32
): Stroke[] {
    const svgNs = 'http://www.w3.org/2000/svg'
    return strokePaths.map((d) => {
        const path = document.createElementNS(svgNs, 'path')
        path.setAttribute('d', d)
        const length = path.getTotalLength()
        const stroke: Stroke = []
        for (let i = 0; i <= samplesPerStroke; i++) {
            const p = path.getPointAtLength((length * i) / samplesPerStroke)
            stroke.push({ x: p.x, y: p.y })
        }
        return stroke
    })
}
